import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useMemo, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { getInitConfig } from 'ziphy-web-shared';
import { setRefs } from 'ziphy-web-shared/basic/helpers';
import { Dropdown, DropdownContent } from 'ziphy-web-shared/basic/lib/functional';
import { $windowSize } from 'ziphy-web-shared/basic/utils';
import { getFilteredCountries } from '../PhoneInput.helpers';
import styles from './PhoneInputDropdown.module.scss';
const PhoneInputDropdown = forwardRef(({ iso2, onClick }, ref) => {
    const dropdownRef = useRef(null);
    const [search, setSearch] = useState('');
    const preferredCountries = useMemo(() => getFilteredCountries({
        preferred: getInitConfig().phone.preferred,
        only: getInitConfig().phone.only,
        excluded: getInitConfig().phone.excluded,
    }).map((item) => (Object.assign(Object.assign({}, item), { id: item.iso2, description: `+${item.dialCode}`, onClick: () => onClick(item) }))), []);
    const filteredCountries = useMemo(() => {
        if (search) {
            let needle = search.trim().toLowerCase().split(' ');
            return preferredCountries.filter((item) => {
                let full = [item.label, '+' + item.dialCode].join(' ').toLowerCase();
                return needle.every((n) => full.includes(n));
            });
        }
        return preferredCountries;
    }, [preferredCountries, search]);
    const maxWidth = Math.min($windowSize.width - 30, 345);
    return (_jsx(Dropdown, Object.assign({ ref: dropdownRef, renderButton: ({ fieldRef, onToggle }) => (_jsx("div", { ref: setRefs(fieldRef, ref), onClick: onToggle, className: classNames(styles.flag, 'flag-icon', 'flag-icon--' + iso2) })), maxWidth: maxWidth, resizeDeps: [search, maxWidth], classNamePopup: styles.popup, direction: ['bottom', 'right'] }, { children: _jsx(DropdownContent, { searchField: { value: search, onChange: setSearch }, items: filteredCountries, classNameItem: styles.item }) })));
});
export default observer(PhoneInputDropdown);
